import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { MaterialService } from './material.service';
import { PartnersOrganizationList } from '../model/partners-organization.model';

@Injectable()
export class PartnersService extends KiwixiService {
  private apiPartnersOrganizations = environment.server + 'partners/organizations/';
  private apiPartnersLoginTicket = environment.server + 'partners/login_ticket/';

  constructor(
    protected _http: HttpClient,
    protected _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    protected materialService: MaterialService,
  ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getPartnersOrganizations(params?: HttpParams): Observable<PartnersOrganizationList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http
      .get<PartnersOrganizationList>(this.apiPartnersOrganizations, { headers: header, params })
      .pipe(catchError(this.handleErrorObservable<any>('getPartnersOrganizations')));
  }

  postLoginTicket(body: { partners_user_email: string; partners_organization_id: number; partners_ttl_minutes?: number; }): Observable<{ url: string }> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http
      .post<{ url: string }>(this.apiPartnersLoginTicket, body, { headers: header })
      .pipe(catchError(this.handleErrorObservable<any>('postLoginTicket')));
  }
}
